module.exports = __webpack_public_path__ + "img/FI.b8f7eddc.svg";